/* eslint-disable @typescript-eslint/no-explicit-any */
export abstract class ObjectUtils {
    public static getObjValueByStr(obj: any, str: string): any {
        try {
            str = str.replace(/\[(\w+)\]/g, '.$1');
            str = str.replace(/^\./, '');
            const partsArr = str.split('.');
            for (let i = 0, n = partsArr.length; i < n; ++i) {
                const part = partsArr[i];
                if (part in obj) {
                    obj = obj[part];
                } else {
                    return;
                }
            }
            return obj;
        } catch (err) {
            return '';
        }
    }
}
